import {GET, POST} from "@/services/gateway";

const getBackupEvents = () => {
  return GET('dashboard/microsoft/backup-events');
}

const list = (data) => {
  return POST('dashboard/microsoft/backup-events', data);
}

const getBackupItems = () => {
  return GET('dashboard/microsoft/backup-items');
}

export {
  getBackupEvents,
  getBackupItems,
  list,
}
